import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space2, space4 } = theme();

  return StyleSheet.create({
    bulletItem: {
      display: "flex",
      flexDirection: "row",
      marginBottom: space2,
      width: "100%",
    },
    bulletItemIconWrapper: {
      display: "flex",
      justifyContent: "center",
      paddingRight: space2,
      width: "auto",
    },
    bulletItemLast: {
      marginBottom: 0,
    },
    bulletItemText: {
      alignItems: "center",
      display: "flex",
      flex: 1,
    },
    bulletsList: {
      paddingBottom: space4,
    },
  });
};

export { style };
